/** The plans with this term's naira prices (dollar prices × the rate in use), for choosing one. */
import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { PLANS, basePrice, perPrice, type PlanId } from '../../services/pricingCore';
import { MEF_CONTACT, naira } from '../../services/billingClient';

const PlanCards: React.FC<{ rate: number; value?: PlanId; onChange?: (p: PlanId) => void; only?: PlanId[]; dark?: boolean }> = ({ rate, value, onChange, only, dark }) => {
    const ids = only || (['ess', 'std', 'pre', 'trn', 'ent'] as PlanId[]);
    return (
        <div className={`grid gap-3 ${ids.length > 4 ? 'sm:grid-cols-2 xl:grid-cols-5' : ids.length > 3 ? 'sm:grid-cols-2 xl:grid-cols-4' : 'sm:grid-cols-3'}`}>
            {ids.map(id => {
                const p = PLANS[id], on = value === id;
                return (
                    <button key={id} type="button" onClick={() => onChange?.(id)} disabled={!onChange}
                        className={`rounded-2xl border-2 p-4 text-left transition ${on ? 'border-emerald-500 bg-emerald-500/10' : dark ? 'border-white/10 bg-white/[0.03] hover:border-white/25' : 'border-slate-200 bg-white hover:border-slate-300 dark:border-slate-700 dark:bg-slate-800'}`}>
                        <div className="flex items-center gap-2">
                            <span className={`font-black ${dark ? 'text-white' : 'text-slate-900 dark:text-white'}`}>{p.name}</span>
                            {on && <CheckCircle2 className="ml-auto h-4 w-4 text-emerald-500" />}
                        </div>
                        {p.contact ? <>
                            <p className={`mt-2 text-lg font-black ${dark ? 'text-white' : 'text-slate-900 dark:text-white'}`}>Contact us</p>
                            <p className="text-xs text-slate-500 select-all">{MEF_CONTACT.email}</p>
                        </> : <>
                            <p className={`mt-2 text-lg font-black ${dark ? 'text-white' : 'text-slate-900 dark:text-white'}`}>{naira(perPrice(id, rate))}<span className="text-xs font-semibold text-slate-500"> / {p.monthly ? 'learner / month' : 'student / term'}</span></p>
                            <p className="text-xs text-slate-500">+ {naira(basePrice(id, rate))} base per {p.monthly ? 'month' : 'term'}</p>
                        </>}
                        <ul className={`mt-3 space-y-1 text-xs ${dark ? 'text-slate-300' : 'text-slate-600 dark:text-slate-300'}`}>
                            {p.summary.map(s => <li key={s}>• {s}</li>)}
                        </ul>
                    </button>
                );
            })}
        </div>
    );
};

export default PlanCards;
